// extracted by mini-css-extract-plugin
export default {"wrap":"NotFoundPage_wrap__RUu4I","content":"NotFoundPage_content__Rl-hG","logo":"NotFoundPage_logo__Hvl6t","decor":"NotFoundPage_decor__tUxb9"};